(function($){

// ---------- APP START
var App = {

  config: {
		scrollOffset: 100
  },

  Tac: function() {
    // window.tarteaucitronForceLanguage = $('html').attr('lang');
    // tarteaucitron.init({
    //   "hashtag": "#tac",
    //   "highPrivacy": false,
    //   "orientation": "bottom",
    //   "adblocker": false,
    //   "showAlertSmall": false,
    //   "cookieslist": true,
    //   "removeCredit": true
    // });

    // tarteaucitron.user.analyticsUa = "UA-128125816-1";
    // (tarteaucitron.job = tarteaucitron.job || []).push("analytics");

    // tarteaucitron.user.googlemapsKey = "AIzaSyCdb9V55VAEdJtQGD7fWH2Z3IQS0_YDIjY";
    // (tarteaucitron.job = tarteaucitron.job || []).push("googlemaps");

    // window.gmap_callback = function() {
    //   App.initMaps();
    // };
  },

  init: function() {

    // Init SVG polyfill
    if(typeof(svg4everybody) !== 'undefined') svg4everybody();

    // Init object-fill polyfill
    if(typeof(objectFitImages) !== 'undefined') objectFitImages();

    // Remove focus state when clicking on a button with a mouse
    $(':not(form) button, a').on('click', function(e){
      if(e.clientX && e.clientY)
        $(this).blur();
    });

    $('a[href^="#"]').on('click', function (e) {
      if ($(this).attr('href') != '#rgpd') {
        e.preventDefault();

        var scrollTo = $(this).data('scroll-to') ? $(this).data('scroll-to') : $(this).attr('href');

        if ($(scrollTo).length > 0 && $(this).data('prevent-scroll') !== true)
          App.scroll(scrollTo, $(this).data('scroll-offset'));
      }
    });

    if($('[data-scroll]').length){
      App.scroll($('[data-scroll]').data('scroll'));
    }

    if($('.form-field').length){
      $('.form-field__input')
        .on('focus', function(){ $(this).removeClass('m--error').closest('.form-field').addClass('is-active'); })
        .on('blur', function(){ if($(this).val().length === 0) $(this).closest('.form-field').removeClass('is-active'); })
        .each(function(){
          if($(this).val().length !== 0){
            $(this).closest('.form-field').addClass('is-active');
          }
        });
    }

    window.addEventListener("popstate", function (e) {
      if (window.location.href.indexOf('#rgpd') == -1) {
        window.location.reload();
      }
    });

    App.initHeaderMenu();
    App.vc.init();


    $('.form-input__wrapper').each(function(i, o) {
      var $this = $(this);
      var $input = $this.find('input');

      if($input.val() !== '')
        $this.addClass('m--label-retracted');

      $input.change(function() {
        if($input.val() !== '')
          $this.addClass('m--label-retracted');
      });

      $input.focus(function() {
        $this.addClass('m--label-retracted');
      });

      $input.blur(function() {
        if($input.val() === '')
          $this.removeClass('m--label-retracted');
      });
    });

    $('.uniform').uniform();

    $('body').on('click', '.btn-ajax-more', function(e) {
      e.preventDefault();
      var $button = $(this);
      var target = $button.data('target');
      var href = $button.attr('href');
      // var custom_query = $(this).data('query');
      $button.attr('disabled', 'disabled');
      $(target).fadeTo(200, 0.5);

      $.ajax({
        url: href,
        success: function(html){
          var content = $(html);
          var newContent = content.find(target).contents();
          var newBtn = content.find('.btn-ajax-more[data-target="' + target + '"]');
          $(target).append(newContent);

          if(newBtn.length > 0)
            $button.attr('href', newBtn.attr('href'));
          else
            $button.fadeOut(200);

          $button.attr('disabled', null);
          $(target).fadeTo(200, 1);
          history.pushState({}, '', href);
        },
        error: function(){
          $button.attr('disabled', null);
        }
      });
    });

  },

  load: function(){
    if (window.location.hash && $(window.location.hash).length) App.scroll(window.location.hash, 100);
  },

  scroll: function(element, offset){
    offset = offset === undefined ? App.config.scrollOffset : offset;
    $('html, body').animate({ scrollTop: $(element).offset().top - offset}, 'slow');
  },

  initHeaderMenu: function() {
    $('.menu-burger').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('m--opened');
      $('body').toggleClass('is-overlayed');
      if($('body').hasClass('m--school-menu-opened')) {
        $('.header-menu-school').toggleClass('m--opened');
      } else {
        $('.header__menu').toggleClass('m--opened');
      }
    });

    // MAIN MENU
    var $main_menu_has_children = $('header .menu-item-has-children');
    $main_menu_has_children.on('mouseout', function(e) {
      if($(window).width() >= 1024) {
        e.preventDefault();
        $(this).removeClass('m--sub-opened');
      }
    });
    $main_menu_has_children.on('mouseover', function(e) {
      if($(window).width() >= 1024) {
        e.preventDefault();
        if (!$(this).hasClass('m--sub-opened'))
          $(this).addClass('m--sub-opened');
      }
    });

    $('header .menu-item-has-children > span.inner > a').click(function(e) {
      if($(window).width() < 1024) {
        e.preventDefault();
				if($(this).parent().parent().hasClass('m--sub-opened')) {
          e.preventDefault();
          $(this).parent().parent().removeClass('m--sub-opened');
          $('.header__menu').removeClass('m--sub-opened');
        }
				else {
					$(this).parent().parent().addClass('m--sub-opened');
					$('header .header__menu').addClass('m--sub-opened');
				}
      }
    });

    $main_menu_has_children.click(function (e) {
      if($(window).width() < 1024) {
        if(e.target != this) return;
        if($(this).hasClass('m--sub-opened')) {
          e.preventDefault();
          $(this).removeClass('m--sub-opened');
          $('.header__menu').removeClass('m--sub-opened');
        }
      }
    });

   /* $('.menu-item-has-children > span.inner > a').click(function(e) {
      if($(window).width() < 1024) {
        if($(this).parent().parent().hasClass('m--sub-opened')) {
          e.preventDefault();
          $(this).parent().parent().removeClass('m--sub-opened');
          $('.header__menu').removeClass('m--sub-opened');
        }
      }
    });*/

    // SCHOOL MENU
    // $('.header-menu-school .header-back__inner').click(function(e) {
    //   $(this).parent().parent().parent().fadeOut(200);
    //   $('body').removeClass('m--school-menu-opened');
    // });
    var $school_menu_has_children = $('.header-menu-school .menu-item-has-children');
    $school_menu_has_children.on('mouseout', function(e) {
      if($(window).width() >= 1014) {
        e.preventDefault();
        $(this).removeClass('m--sub-opened');
      }
    });
    $school_menu_has_children.on('mouseover', function(e) {
      if($(window).width() >= 1014) {
        e.preventDefault();
        if (!$(this).hasClass('m--sub-opened')) {
          $(this).addClass('m--sub-opened');
          // $('.header-menu-school__img').attr('data-polyclip','16%, 6%, 58%, 0, 89%, 11%, 100%, 41%, 89%, 88%, 60%, 98%, 8%, 86%, 1%, 45%');
          // polyClip.init();
        }
      }
    });
    var $school_menu_item = $('.header-menu-school .menu-item-has-children .menu-item > span.inner > a');
    $school_menu_item.on('mouseout', function(e) {
      if($(window).width() >= 1014) {
        e.preventDefault();
        var $img = $(this).parent().parent().find('.header-menu-school__img-wrap');
       // $img.stop(1, 0).fadeOut(200);
				$img.stop(1, 0).fadeOut(200);
      }
    });
    $school_menu_item.on('mouseover', function(e) {
      if($(window).width() >= 1014) {
        e.preventDefault();
        var $img = $(this).parent().parent().find('.header-menu-school__img-wrap');
       /* if($img.length > 0) {
          $img.attr('data-polyclip', '16%, 6%, 58%, 0, 89%, 11%, 100%, 41%, 89%, 88%, 60%, 98%, 8%, 86%, 1%, 45%');
          poly = polyClip.init();
          //$img.stop(1, 0).fadeIn(200);
					$($img).parent().addClass('active');
        } else {*/
          $img.stop(1, 0).fadeIn(200);
        //}
      }
    });
    $('.header-menu-school .menu-item-has-children > span.inner').click(function(e) {
			e.preventDefault();
      if($(window).width() < 1024) {
       // if(e.target != this) return;
        if(!$(this).parent().hasClass('m--sub-opened')) {
          $(this).parent().addClass('m--sub-opened');
          $(this).children('.menu-sub-bigmenu').addClass('m--sub-opened');
        } else {
          $(this).parent().removeClass('m--sub-opened');
          $(this).children('.menu-sub-bigmenu').removeClass('m--sub-opened');
        }
      }
    });

    $('.header-menu-school .header__back').click(function(e) {
      $('.header__menu').addClass('m--opened');
      $('.header-menu-school').removeClass('m--opened');
      $('body').removeClass('m--school-menu-opened');
    });
  },


  vc: {

    init: function() {
      if($('.ecam-big-first-block').length) App.vc.initBigFirstBlock();
      if ($('.ecam-newsletter').length) App.vc.initFormNewsletter();
      $(".counter").countimator();
      if($('.ecam-map-schools').length) App.vc.initMapSchools();
      if($('.ecam-specificities-list__slider').length) App.vc.initSliderSpecificities();
      if($('.ecam-contact-form').length) App.vc.initContactForm();
			if($('.ecam-coords__schools-list').length) App.vc.initListSchools();
    },

    initBigFirstBlock: function() {
      $('.ecam-big-first-block__scrolldown').click(function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: $('.ecam-big-first-block').outerHeight() - 150 });
      });

      var $video = $('.ecam-big-first-block__video');
      if($video.length > 0) {
        $video.tubular({videoId: $video.attr('data-videoid')});

        window.onPlayerStateChange = function (state) {
          if (state.data === 1) {
            $('.ecam-big-first-block__video-poster').fadeOut(500);
          }
          if (state.data === 0) {
            window.player.seekTo(0);
          }
        };
      }

    },

    initFormNewsletter: function() {
      $('.ecam-newsletter form').submit(function(e) {
        e.preventDefault();
        var $form = $(this);
        var $parent = $form.parent();
        var $button = $form.find('button');
        var $email = $form.find('input[name="ns_email"]');
        $email.parent().removeClass('is_error');

        if(validateEmail($email.val())) {
          $button.attr('disabled', 'disabled');
          jQuery.post(
            ajaxurl+'?action=addviso_newsletter_subscribe',
            $form.serialize(),
            function(response){
              $email.attr('disabled', null);
              $button.attr('disabled', null);
              if(response.status == 'success') {
                $form.fadeOut(200, function(){
                  $parent.find('.form-newsletter-success').fadeIn(200);
                });
                if(ga !== undefined)
                  ga('send', 'event', 'Form', 'Submit', 'Inscription Newsletter');
              } else {
                $email.parent().addClass('is_error');
              }
            }, 'json'
          );
        } else {
          $email.parent().addClass('is_error');
        }
      });
    },

    initMapSchools: function() {
      var marker_ecam = L.icon({ iconUrl: '/themes/eca-morlaix/assets/images/pictos/marker_ecam.png', iconSize: [48, 59], iconAnchor: [24, 56] });
      var marker_blue = L.icon({ iconUrl: '/themes/eca-morlaix/assets/images/pictos/marker_blue.png', iconSize: [48, 59], iconAnchor: [24, 56] });
      var marker_green = L.icon({ iconUrl: '/themes/eca-morlaix/assets/images/pictos/marker_green.png', iconSize: [48, 59], iconAnchor: [24, 56] });
      var marker_green_2 = L.icon({ iconUrl: '/themes/eca-morlaix/assets/images/pictos/marker_green_2.png', iconSize: [48, 59], iconAnchor: [24, 56] });
      var marker_orange = L.icon({ iconUrl: '/themes/eca-morlaix/assets/images/pictos/marker_orange.png', iconSize: [48, 59], iconAnchor: [24, 56] });
      var marker_purple = L.icon({ iconUrl: '/themes/eca-morlaix/assets/images/pictos/marker_purple.png', iconSize: [48, 59], iconAnchor: [24, 56] });
      var marker_purple_2 = L.icon({ iconUrl: '/themes/eca-morlaix/assets/images/pictos/marker_purple_2.png', iconSize: [48, 59], iconAnchor: [24, 56] });
      var marker_rose = L.icon({ iconUrl: '/themes/eca-morlaix/assets/images/pictos/marker_rose.png', iconSize: [48, 59], iconAnchor: [24, 56] });
      var marker_yellow = L.icon({ iconUrl: '/themes/eca-morlaix/assets/images/pictos/marker_yellow.png', iconSize: [48, 59], iconAnchor: [24, 56] });

      var markers = [
        L.marker([48.5747526,-3.837209], {icon: marker_ecam}), // Siège Social L'ECA.M
        L.marker([48.5737102,-3.826103], {icon: marker_yellow}), // École Saint Joseph
        L.marker([48.574137,-3.836629], {icon: marker_purple_2}), // École Notre Dame De Lourdes
        L.marker([48.518553, -3.944306], {icon: marker_green_2}), // École Sacré Coeur
        L.marker([48.5745059,-3.8405325], {icon: marker_rose}), // Collège Saint Augustin
        L.marker([48.5737102,-3.826103], {icon: marker_blue}), // Collège Saint Joseph
        L.marker([48.518225, -3.943631], {icon: marker_green}), // Collège Sainte Marie
        L.marker([48.5747526,-3.837309], {icon: marker_purple}), // Lycée Le Porsmeur
        L.marker([48.5747526,-3.837409], {icon: marker_orange}), // Lycée Notre Dame Du Mur
      ];

      $('.ecam-map-schools').each(function(i, o) {
        var $map_el = $(this).find('.ecam-map-schools-map__map');
        var map_el = $(this).find('.ecam-map-schools-map__map').get(0);
        var map = L.map(map_el, { scrollWheelZoom: false });
        map.setView(new L.LatLng(48.1145724,-1.6774266), 18);
        map.addLayer(new L.TileLayer('//cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {minZoom: 5, maxZoom: 18}));

        var group = null;
        if($(this).hasClass('m--one')) {
          var gps = $map_el.attr('data-coords').split(',');
          var marker_icon = $map_el.attr('data-marker');
          var marker = L.marker([gps[0],gps[1]], {icon: L.icon({ iconUrl: '/themes/eca-morlaix/assets/images/pictos/'+marker_icon, iconSize: [48, 59], iconAnchor: [24, 56] })});
          group = L.featureGroup([marker]).addTo(map);
        } else {
          group = L.featureGroup(markers).addTo(map);
        }

        setTimeout(function () {
          map.fitBounds(group.getBounds());
        }, 1000);
      });
    },

		initListSchools: function() {
			var parent = $('#map-schools-legends');
			var card = $('#school-card');
			var currentTab = null;

				$('.ecam-map__school').on('click', function(e) {
						var infosTab = $(this).attr('data-infos').split('|');
						$('.ecam-location-school__title').html(infosTab[1]);
						$('.ecam-location-school__email').attr('href','mailto:'+infosTab[2]).html(infosTab[2]);
						$('.ecam-location-school__tel').attr('href','tel:'+infosTab[3]).html(infosTab[3]);
						$('.ecam-location-school__address').html(infosTab[4]);
						$('.ecam-location-school__link').attr('href',infosTab[5]);
						currentTab = 'm--' + infosTab[0];
						parent.addClass('opened');
						card.addClass(currentTab);
				});
				$('#btn-close').on('click', function(e) {
						parent.removeClass('opened');
						card.removeClass(currentTab);
				});
		},

    initSliderSpecificities: function() {
      $('.ecam-specificities-list__slider').slick({
        arrows: true,
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: '<button type="button" class="slick-prev"><svg role="img" class="svg-icon icon-arrow-simple-right "><use xlink:href="/themes/eca-morlaix/assets/images/pictos/misc.sprite.svg#icon-arrow-simple-left"></use></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg role="img" class="svg-icon icon-arrow-simple-right "><use xlink:href="/themes/eca-morlaix/assets/images/pictos/misc.sprite.svg#icon-arrow-simple-right"></use></svg></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    },

    initContactForm: function() {
      $('.ecam-contact-form').each(function(i, o) {
        var $form = $(this).find('form');
        var $success = $(this).find('.ecam-contact-form__success');
        var $submit = $(this).find('button');

        $form.submit(function(e) {
          e.preventDefault();
          $(this).find('.m--error').removeClass('m--error');
          $submit.prop('disabled', true);
          jQuery.post(
            ajaxurl+'?action=contact_send',
            $(this).serialize(),
            function(response){
              $submit.prop('disabled', false);
              if(response.status == 'ok') {
                $form.hide();
                $success.show();
                if(ga !== undefined)
                  ga('send', 'pageview', '/demande-contact-ok');
              } else if(response.status != '403') {
                for(var i = 0 ; i < response.field.length ; i++) {
                  $form.find("*[data-label='"+response.field[i]+"']").addClass('m--error');
                }
              }
            }, 'json'
          );
        });
      });
    }
  }
};
// ---------- APP END

// Init app
$(document).ready(App.init);
// $(window).load(App.load); // jQuery 2
$(window).on('load', App.load); // jQuery 3
window.App = App;
// App.Tac();
})(jQuery);

// ---------- MISSING FUNCTIONS
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
// ---------- MISSING FUNCTIONS END
